import Model from "../../core/model/Model";
import ValidatableObject from "../../core/model/validation/ValidatableObject";

export interface TInstitutionDetails {
  institutionType: string;
  headquartersName: string;
  jurisdictionName: string;
  jurisdictionType: string;
}

export interface IInstitutionDetails extends TInstitutionDetails {}

const InstitutionDetails = Model(
  (model: TInstitutionDetails): IInstitutionDetails => {
    const _value: TInstitutionDetails = Object.assign({}, model);

    let _model = {
      get institutionType() {
        return _value.institutionType;
      },
      set institutionType(value) {
        _value.institutionType = value;
      },
      get headquartersName() {
        return _value.headquartersName;
      },
      set headquartersName(value) {
        _value.headquartersName = value;
      },
      get jurisdictionName() {
        return _value.jurisdictionName;
      },
      set jurisdictionName(value) {
        _value.jurisdictionName = value;
      },
      get jurisdictionType() {
        return _value.jurisdictionType;
      },
      set jurisdictionType(value) {
        _value.jurisdictionType = value;
      }
    };

    return ValidatableObject<IInstitutionDetails>(_model);
  }
);

export default InstitutionDetails;
